/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KnownClientResource
 */
export interface KnownClientResource {
    /**
     * 
     * @type {string}
     * @memberof KnownClientResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof KnownClientResource
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof KnownClientResource
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof KnownClientResource
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof KnownClientResource
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof KnownClientResource
     */
    photoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof KnownClientResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof KnownClientResource
     */
    companyName: string;
    /**
     * 
     * @type {Date}
     * @memberof KnownClientResource
     */
    lastMessageDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof KnownClientResource
     */
    canWorkWithSubcontractor?: boolean;
}

/**
 * Check if a given object implements the KnownClientResource interface.
 */
export function instanceOfKnownClientResource(value: object): value is KnownClientResource {
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    return true;
}

export function KnownClientResourceFromJSON(json: any): KnownClientResource {
    return KnownClientResourceFromJSONTyped(json, false);
}

export function KnownClientResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): KnownClientResource {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'fullName': json['fullName'],
        'email': json['email'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'companyId': json['companyId'],
        'companyName': json['companyName'],
        'lastMessageDate': json['lastMessageDate'] == null ? undefined : (new Date(json['lastMessageDate'])),
        'canWorkWithSubcontractor': json['canWorkWithSubcontractor'] == null ? undefined : json['canWorkWithSubcontractor'],
    };
}

export function KnownClientResourceToJSON(value?: KnownClientResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'fullName': value['fullName'],
        'email': value['email'],
        'photoUrl': value['photoUrl'],
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'lastMessageDate': value['lastMessageDate'] == null ? undefined : ((value['lastMessageDate']).toISOString()),
        'canWorkWithSubcontractor': value['canWorkWithSubcontractor'],
    };
}

